// src/components/ProtectedRoute.tsx

import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/firebaseAuth';
import { getDocumentById } from '../utility/firebaseHelpers';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { currentUser } = useAuth();
  const location = useLocation();
  const [userStatus, setUserStatus] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUserStatus = async () => {
      if (!currentUser) {
        setLoading(false);
        return;
      }

      try {
        const userDoc = await getDocumentById('users', currentUser.uid);
        setUserStatus(userDoc?.status || 'active');
      } catch (error) {
        console.error('Error checking user status:', error);
        setUserStatus('active');
      } finally {
        setLoading(false);
      }
    };

    checkUserStatus();
  }, [currentUser]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!currentUser) {
    // Redirect to login and pass the original route as state
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is banned, redirect to banned page
  if (userStatus === 'banned') {
    return <Navigate to="/account-banned" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
